import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    SET_USER: 'SET_USER',
    GET_UAM_BUSINESS_FUNCTIONS: createAsyncActionConstants('GET_UAM_BUSINESS_FUNCTIONS'),
    GET_CT_UAM_BUSINESS_FUNCTIONS: createAsyncActionConstants('GET_CT_UAM_BUSINESS_FUNCTIONS'),
    GET_CUSTOMS_UAM_BUSINESS_FUNCTIONS: createAsyncActionConstants('GET_CUSTOMS_UAM_BUSINESS_FUNCTIONS'),
    GET_DP_UAM_BUSINESS_FUNCTIONS: createAsyncActionConstants('GET_DP_UAM_BUSINESS_FUNCTIONS'),
    CHECKING_FOR_ROLES: createAsyncActionConstants('CHECKING_FOR_ROLES')
}